import {Button, Drawer, message, Space} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import {useGetCustomerStoreServicesOrdersContext} from "../../../../../../../service-feature/useCases/get-orders/context/customer";
import {useCustomerApproveStoreServiceOrderApi} from "../../../../../../../react-query-hooks/store/services/approve-store-service-order";
import {mapStatusIdToStatus} from "../../../list/list";
import {StyledStoreServiceOrderDrawer} from "../styles";

export function CustomerStoreServiceApproveOrderDrawer() {
  const {
    state: {selectedStoreServiceOrderInfo, activeStoreServiceOrderDrawer},
    dispatch,
  } = useGetCustomerStoreServicesOrdersContext();
  const customerApproveStoreServiceOrderApi = useCustomerApproveStoreServiceOrderApi();
  if (!selectedStoreServiceOrderInfo) return null; // or show a loader/skeleton
  const onOrderInfoDrawerClose = () => {
    dispatch({
      type: "set-active-store-service-order-drawer",
      payload: "order-info",
    });
  };
  return (
    <StyledStoreServiceOrderDrawer
      title={selectedStoreServiceOrderInfo.productService.name}
      placement="right"
      onClose={onOrderInfoDrawerClose}
      visible={activeStoreServiceOrderDrawer === "approve-delivery"}
      closable={false}
      extra={
        <Button size="small" type="text" onClick={onOrderInfoDrawerClose}>
          <CloseOutlined />
        </Button>
      }
    >
      <div>
        <Space size={24} direction="vertical" style={{display: "flex"}}>
          <p>
            By approving this delivery, you're confirming that this service has been
            completed to your satisfaction.
            <br />
            Once approved, your coach will be credited and the order will be marked as
            completed.
          </p>
          <div>
            <Button
              onClick={() => {
                if (
                  mapStatusIdToStatus(selectedStoreServiceOrderInfo.order.statusId) ===
                  "delivered"
                ) {
                  customerApproveStoreServiceOrderApi.mutate(
                    {
                      orderId: selectedStoreServiceOrderInfo.order.id,
                    },
                    {
                      onSuccess() {
                        message.success("Order delivery approved successfully");
                        dispatch({
                          type: "update-status-id",
                          payload: 3,
                        });
                        onOrderInfoDrawerClose();
                      },
                    }
                  );
                } else {
                  message.error(
                    `You cannot perform this action with this status => ${mapStatusIdToStatus(
                      selectedStoreServiceOrderInfo.order.statusId
                    )}`
                  );
                }
              }}
              loading={customerApproveStoreServiceOrderApi.isLoading}
              size="small"
              type="primary"
              disabled={
                mapStatusIdToStatus(selectedStoreServiceOrderInfo.order.statusId) !==
                "delivered"
              }
              title={
                mapStatusIdToStatus(selectedStoreServiceOrderInfo.order.statusId) !==
                "delivered"
                  ? `You cannot approve an order that is not yet delivered, current status is ${mapStatusIdToStatus(
                      selectedStoreServiceOrderInfo.order.statusId
                    )}`
                  : undefined
              }
            >
              Approve
            </Button>
          </div>
        </Space>
      </div>
    </StyledStoreServiceOrderDrawer>
  );
}
